export const TITLE = 'title'
export const TEXT = 'text'
export const REF_LINK = 'ref_link'